import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useNavigate, Link } from "react-router-dom";
import { ChevronDown, Menu } from "lucide-react";
import { usePostHog } from "posthog-js/react";
import { USER_GUIDE_URL } from "@/constants";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const navigate = useNavigate();
  const posthog = usePostHog();

  return (
    <nav className="sticky top-0 z-50 bg-[#131a21] py-4">
      <div className="container flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src={"/images/new-logo.svg"}
            alt=""
            className="relative z-10 mx-auto h-6 w-52 md:h-7 md:w-52 lg:w-52"
          />
        </div>

        <div className="hidden items-center gap-4 md:hidden lg:flex">
          <ul className="hidden items-center gap-10 font-inter font-medium text-[#fff] md:flex">
            <Link
              to="#about-us"
              className="cursor-pointer"
              onClick={() =>
                posthog?.capture("nav_clicked", {
                  label: "About Us",
                  destination: "#about-us",
                  location: "navbar",
                })
              }
            >
              About Us
            </Link>
            <Link
              to="#"
              onClick={() => {
                posthog?.capture("nav_clicked", {
                  label: "User Guide",
                  destination: "user_guide_pdf",
                  location: "navbar",
                });
                window.open(USER_GUIDE_URL, "_blank");
              }}
              className="cursor-pointer"
            >
              User Guide
            </Link>

            <Link
              to="#"
              className="cursor-pointer"
              onClick={() =>
                posthog?.capture("nav_clicked", {
                  label: "Request Demo",
                  destination: "#",
                  location: "navbar",
                })
              }
            >
              Request Demo
            </Link>
          </ul>
          <Button
            className="font-Inter h-[44px] w-[140px] rounded-[12px] border border-white/50 text-[#fff]"
            variant="outline"
            size="sm"
            onClick={() => {
              navigate("/sign-in");
            }}
            trackingEvent="login_clicked"
            trackingProperties={{ location: "navbar" }}
          >
            Login
          </Button>
        </div>

        <div className="block text-white md:block lg:hidden">
          <Menu
            size={24}
            className="cursor-pointer"
            onClick={() => setToggle(!toggle)}
          />
        </div>

        {toggle && (
          <div className="bg-dark absolute right-0 top-14 p-5">
            <ul className="grid items-center gap-4 text-[#fff]">
              <li>
                <Link
                  to="/about-us"
                  className="font-Inter cursor-pointer text-base"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  onClick={() =>
                    window.open(USER_GUIDE_URL, "_blank")
                  }
                  className="font-Inter cursor-pointer text-base"
                >
                  User Guide
                </Link>
              </li>
              <div className="flex items-center gap-2">
                <Link
                  // to='/faq'
                  to="#"
                  className="font-Inter cursor-pointer text-base"
                >
                  Request Demo
                </Link>
                <ChevronDown />
              </div>
            </ul>
            <div className="mt-5 flex items-center gap-4">
              <Button
                className="font-Inter h-[44px] w-[140px] rounded-md border border-[#fff] text-[#fff]"
                variant="outline"
                onClick={() => {
                  navigate("/sign-in");
                }}
                trackingEvent="login_clicked"
                trackingProperties={{ location: "mobile_menu" }}
              >
                Login
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
